import React from 'react';
import styles from './NumPad.module.css';

interface NumPadProps {
  onDigit: (digit: string) => void;
  onDelete: () => void;
  onClear: () => void;
}

/**
 * 3x4 숫자 키패드
 * 1-9, 전체삭제(C), 0, 한자리삭제(<-)
 */
export function NumPad({ onDigit, onDelete, onClear }: NumPadProps) {
  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

  return (
    <div className={styles.grid}>
      {digits.map((d) => (
        <button
          key={d}
          className={styles.key}
          onClick={() => onDigit(d)}
          type="button"
        >
          {d}
        </button>
      ))}
      <button
        className={styles.keyAction}
        onClick={onClear}
        type="button"
      >
        C
      </button>
      <button
        className={styles.key}
        onClick={() => onDigit('0')}
        type="button"
      >
        0
      </button>
      <button
        className={styles.keyAction}
        onClick={onDelete}
        type="button"
      >
        &#8592;
      </button>
    </div>
  );
}
